<template>
  <div
    v-if="horizontal"
    :class="[_.horizontal, goodsList.length === 2 && _.two]"
  >
    <x-goods-item
      v-for="(item, index) in goodsList"
      :key="`${item.id}.${index}`"
      :item="item"
      :index="index"
      :horizontal="horizontal"
      :has-serial-no="hasSerialNo"
      :track="track"
      :class="_.item"
      :style="{ width: `${itemWidthRem}rem` }"
    />
  </div>
  <x-masonry v-else :col-count="one ? 1 : 2" :col-gap="8" :row-gap="8">
    <slot name="first" />
    <x-goods-item
      v-for="(item, index) in goodsList"
      :key="`${item.id}.${index}`"
      :item="item"
      :index="index"
      :one="one"
      :has-serial-no="hasSerialNo"
      :track="track"
    />
  </x-masonry>
</template>

<script>
  import Vue from 'vue'
  import { makeUniGoods, pxToRem } from '@/utils'
  import { range } from 'vtils'

  export default Vue.extend({
    props: {
      data: {
        type: Array,
        default: () => range(1, 12),
      },
      one: {
        type: Boolean,
        default: false,
      },
      horizontal: {
        type: Boolean,
        default: false,
      },
      itemWidth: {
        type: Number,
        default: 140,
      },
      hasSerialNo: {
        type: Boolean,
        default: false,
      },
      track: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      goodsList() {
        return makeUniGoods(this.data)
      },
      itemWidthRem() {
        return pxToRem(this.itemWidth)
      },
    },
  })
</script>

<style lang="scss" module>
  .horizontal {
    display: block;
    white-space: nowrap;
    /** 必须同时设置 y 上的，否则 iOS 13 会有拖拽效果 */
    /** 不能用简写形式（overflow: auto hidden），iPhone6s有问题 */
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }

    .item {
      display: inline-block;
      width: 140px;

      &:not(:first-child) {
        margin-left: 12px;
      }
    }

    &.two {
      display: flex;

      .item {
        flex: 1;
      }
    }
  }
</style>
